import { Rate } from './../Rate/Rate.model';
import { PrepaidRoomCluster } from '../PrepaidRoomCluster/PrepaidRoomCluster.model';

export class DisneyRoomCluster extends PrepaidRoomCluster {
  public bestRate: Rate;
  public hasTickets: boolean;
  public hasMealPlans: boolean;
  public hasRoomOnlyOption: boolean;

  constructor(data: PrepaidRoomCluster) {
    super(data);
  }

  public static onlyRoomOption(rates: Rate[]): boolean {
    return rates.every((rate: Rate) => rate.supplements && rate.supplements.length === 0);
  }
}
